import JobCollection from '../../models/JobCollection'

export default {
    columns (state) {
        return state.columns.sort((a, b) => a.position - b.position)
    },

    availableJobs (state, getters) {
        // We create a new collection and clone the job items to avoid
        // an infinite loop as vue reacts to any change within the collection
        let jobs = new JobCollection(JSON.parse(JSON.stringify(state.jobs.items)))

        if (getters.filtersCount > 0) {
            jobs = jobs.filters(state.filters)
        }

        return jobs
    },

    jobs: (state, getters) => (columnId) => {
        return getters.availableJobs.where('column_id', columnId).sortBy('position').all()
    },

    guests (state, getters) {
        return getters.activeAndPendingMembers.filter(user => user.is_guest === true)
    },

    notGuests (state, getters) {
        return getters.activeAndPendingMembers.filter(user => user.is_guest === false)
    },

    activeMembers (state) {
        return state.members.filter(user => user.is_active)
    },

    sortedPeople (state, getters) {
        return getters.notGuests.concat(getters.guests)
    },

    activeAndPendingMembers (state) {
        return state.members.filter(user => user.is_active || user.is_pending)
    },

    filtersCount (state) {
        return Object.keys(state.filters).reduce((carry, filter) => {
            return carry + state.filters[filter].length
        }, 0)
    }
}
